"use client"

import { useIsDesktop } from "@/hooks/app/useIsDesktop"

import { Button, Card, Col, Divider, Row, Skeleton, theme } from "antd"
import { FC } from "react"
import { CardProps } from "antd/lib"

type FormSearchMobileSkeletonProps = CardProps & {
  onSearch?: () => void
}

const FormSearchMobileSkeleton: FC<FormSearchMobileSkeletonProps> = ({ onSearch, className, style, ...props }) => {
  const isDesktop = useIsDesktop()
  const token = theme.useToken().token

  if (isDesktop) {
    return <></>
  }
  return (
    <Card
      {...props}
      className={className}
      size='small'
      style={{ zIndex: 1, boxShadow: token.boxShadow, ...style }}
    >
      <Row style={{ minHeight: '6.74rem' }} align='middle'>
        <Col span={24}>
          <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '4rem', width: '100%' } }} />
        </Col>
      </Row>
      <Divider style={{ marginTop: 0, marginBottom: '1rem' }} />
      <Button
        type='text'
        style={{ height: 'auto', minHeight: 'auto', justifyContent: 'start', paddingBlock: '1rem' }}
        block
        icon={<Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '3rem', width: '3rem' } }} />}
        iconPlacement='start'
      >
        <Row wrap={false} style={{ width: '100%' }} justify='space-between' align='middle' gutter={[20, 20]}>
          <Col flex={1}>
            <Row gutter={[5, 5]} wrap={false}>
              <Col flex={1}>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '3.8rem', width: '100%' } }} />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row style={{ marginBottom: '0.4rem' }}>
              <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '2rem', width: '2rem' } }} />
            </Row>
            <Row justify='center'>
              <Col>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '1.6rem', width: '1.6rem' } }} />
              </Col>
            </Row>
          </Col>
          <Col flex={1}>
            <Row gutter={[5, 5]} wrap={false}>
              <Col flex={1}>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '3.8rem', width: '100%' } }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Button>
      <Button
        iconPlacement='start'
        type='text'
        style={{ height: '6.74rem', minHeight: 'auto', justifyContent: 'start', fontWeight: '500' }}
        icon={<Skeleton paragraph={false} styles={{ title: { height: '3rem', width: '3rem', margin: 0 } }} />}
        block
      >
        <Row style={{ width: '100%' }}>
          <Col flex={1}>
            <Skeleton paragraph={false} styles={{ title: { height: '1.6rem', width: '100%', margin: 0 } }} />
          </Col>
        </Row>
      </Button>
      <Divider style={{ marginBlock: '1rem' }} />
      <Skeleton.Button
        size='large'
        block
        active
        style={{
          height: '4rem'
        }}
      />
    </Card>
  )
}

export default FormSearchMobileSkeleton